var m = require('mithril');

function withNavigation(attrs, options) {
  if (options && typeof options.onNavigate === 'function') {
    attrs.onclick = options.onNavigate;
  }
  return attrs;
}

function currentQueryString(options) {
  if (options && typeof options.queryString === 'string') {
    return options.queryString;
  }
  return (m.route.get() || '').split('?')[1] || '';
}

function items(originColumn, options) {
  var column = originColumn || {};
  var path = Array.isArray(column.path) ? column.path : [];
  var queryString = currentQueryString(options);
  var headerPath = [];

  path.forEach(function (ancestor) {
    if (ancestor.name === 'root') {
      headerPath.push(
        m('div.mr2.nowrap', [
          m(m.route.Link, withNavigation({ href: '/' }, options), 'Home'),
          m('span', ' / ')
        ])
      );
    } else if (typeof ancestor.name === 'string' && ancestor.name[0] === '-') {
      return;
    } else if (ancestor['@class'] === 'Element' || ancestor['@class'] === 'Dataset') {
      if (ancestor.url) {
        headerPath.push(
          m('div.mr2.nowrap.truncate', [
            m('a', withNavigation({ href: ancestor.url }, options), ancestor.name),
            m('span', ' - ')
          ])
        );
      } else {
        headerPath.push(
          m('div.mr2.nowrap.truncate', [
            ancestor.name,
            m('span', ' - ')
          ])
        );
      }
    } else if (['Site', 'Building', 'Level', 'Room'].indexOf(ancestor['@class']) > -1) {
      headerPath.push(
        m('div.mr2.nowrap.truncate', [
          m(m.route.Link, withNavigation({
            href: '/location/' + ancestor['@rid'].slice(1) + (queryString ? '?' + queryString : '')
          }, options), ancestor['@class'] === 'Room'
            ? ancestor.name + ' ' + ancestor.roomNumber
            : ancestor.name),
          ' / '
        ])
      );
    } else if (ancestor['@class'] === 'Dashboard') {
      headerPath.push(
        m('div.mr2.nowrap.truncate', [
          m(m.route.Link, withNavigation({
            href: '/dashboard/' + ancestor['@rid'].slice(1)
          }, options), ancestor.name || ancestor['@class']),
          ' / '
        ])
      );
    } else {
      headerPath.push(
        m('div.mr2.nowrap.truncate', [
          m(m.route.Link, withNavigation({
            href: '/equipment/' + ancestor['@class'].toLowerCase() + '/' + ancestor['@rid'].slice(1)
          }, options), ancestor.name || ancestor['@class']),
          ' / '
        ])
      );
    }
  });

  headerPath.push(m('div.mr2.dib-ns', column.name));
  return headerPath;
}

module.exports = {
  items: items
};
